/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Info_Cod_HintInputs */

const vi_print_info_cod_hint = /** @type {(inputs: Print_Info_Cod_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số tiền in trên phiếu cho lần in này. Không đổi công nợ của đơn.`)
};

/**

* @param {Print_Info_Cod_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_info_cod_hint = /** @type {((inputs?: Print_Info_Cod_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Info_Cod_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_info_cod_hint(inputs)
});